module.exports = "/assets/ded18889743424d587ff1cd22f9be3e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2Q.png
// module id = 992
// module chunks = 0